import { get, generateSearchParams } from './common';

export default {
    getInventory: async (params, token) => get(`/v1/Auction/SearchInventory${generateSearchParams(params)}`, token),
    getInventorySearchCriteria: async (params, token) => get(`/v1/Auction/GetInventorySearchCriteria`, token),
    getModelsForMakes: async (params, token) => get(`/v1/Auction/GetModelsForMakes?makes=${params.makes}`, token),
};